import { RESTAURANTS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

// src/Services/fetchGetMyRestaurants.js
export const fetchGetMyRestaurants = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(RESTAURANTS.getMyRestaurants, method);

    // console.log("👉 Respuesta cruda de getMyRestaurants:", response);

    if (response.code === 200) {
        return response; // aquí probablemente traiga { items, count }
    } else {
        throw new Error(response.message || "Error al obtener mis restaurantes");
    }
};

